import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { Api } from '../../../providers';
import { Form } from '../../../providers/survey';
import { TrackingFasker, TrackingAsset } from '@providers/index';
import { DetailItemFaskerPage } from '../';

import { UserMyRadiant as User, RepositoryMyRadiant } from '../../../providers';

import { cmpFilterKaryawan } from "../../../components/presensi";

import { FormItemFaskerPage } from '../';

@Component({
  selector   : 'page-listItemFasker',
  templateUrl: 'index.html'
})
export class ListItemFaskerPage {
  
  profile           : any;
  form              : any={};
  form_id = 0;

  list_item : any = [];
  total_item = 0;
  list_item_edited : any = [];
  total_item_edited = 0;
  list_item_moved : any = [];

  tracking_active : any = {};

  user_data         : any={};

  user_id = this.userApi.data.Employee_ID;

  loading : any;

  constructor(
    public navCtrl            : NavController,
    public navParams          : NavParams,
    public loadingCtrl        : LoadingController,
    public toastCtrl          : ToastController,
    public modalCtrl          : ModalController,
    public api                : Api,
    public formApi            : Form,
    public trackFaskerApi     : TrackingFasker,
    public trackingApi        : TrackingAsset,
    public userApi            : User,
    public repositoryMyRadiant: RepositoryMyRadiant
    ) {

    this.form_id = navParams.get('form_id');
    this.tracking_active = navParams.get('tracking');

    this.user_data = this.userApi.data;
    console.log("data user => ", this.user_data);

  }

  /**
   * The view loaded, let's query our items for the list
   */
  ionViewDidEnter() {
    this.getForm()
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getForm();
  }

  public getForm(){
      this.showLoading();
  
      let params:any = {
        form_id : this.form_id
      };
      this.formApi.get(params).subscribe((resp:any) => {
        console.log('getListForm =>',resp);
        if(resp.success){
          this.form  = resp.data[0];
          console.log("form => ", this.form);
          // this.total_data = resp.total_rows;

          this.getListData();
        }
  
        this.loading.dismiss();
      },(err) => {
        console.log(err);
        this.loading.dismiss();
      });
    
  }

  public getListData(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      user_id   : this.user_id,
      form_id   : this.form_id
    };

      this.trackFaskerApi.getItemTracking(params).subscribe((resp:any) => {
        console.log("data response => ",resp.data);
        if(resp.success){
          this.list_item = resp.data
          this.total_item = resp.total_rows
        }else{
          this.presentToast("Error while loading data !")
        }

        this.trackFaskerApi.getItemFaskerTracking(params).subscribe((resp:any) => {
          console.log("data response => ",resp.data);
          this.list_item_edited = [];
          this.list_item_moved = [];
          if(resp.success){
            if(resp.data.length > 0){
              resp.data.forEach(rec => {
                if(rec.updated_by == this.user_data.employee_id && rec.tracking_act != null){
                  this.list_item_edited.push(rec);
                }
                if(rec.asset_user_id == this.user_data.employee_id && rec.asset_user_id != rec.updated_by && rec.tracking_act != null){
                  this.list_item_moved.push(rec);
                }
              });
            }
            // this.list_item_edited = resp.data
            // this.total_item_edited = resp.total_rows
            console.log("resp data list tracking => ", resp.data)
          }else{
            this.presentToast("Error while loading data !")
          }
        }, (err) => {
               
        });

        loading.dismiss();
      }, (err) => {
        loading.dismiss();     
      });

  }

  addItem() {
    this.navCtrl.push(FormItemFaskerPage, {
      form_id   : this.form_id,
      tracking_active  : this.tracking_active,
      src : 'add'     
    });
  }

  // toEditResponse(item) {
  //   this.navCtrl.push(FormPage, {
  //     data : item,
  //     form : this.form,
  //     TY_entry_count : {
  //       today     : this.count_todays_entry,
  //       yesterday : this.count_yesterdays_entry
  //     }
  //   });
  // }
  toDetail(item) {
    this.navCtrl.push(DetailItemFaskerPage, {
      id : item.id,
      tracking : this.tracking_active,
      src : 'old'
    });
  }
  toDetailNew(item) {
    this.navCtrl.push(DetailItemFaskerPage, {
      id : item.id,
      tracking : this.tracking_active,
      src : 'new'
    });
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }
  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  showMyTeamData(){
    let me = this;
    this.showLoading();
    let params = {
      id : this.user_data.Employee_ID
    };
    this.repositoryMyRadiant.checkBeforeGetBawahan(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      if(resp.success){
        let karyawanModal = this.modalCtrl.create(cmpFilterKaryawan, {
          karyawan      : resp.data.list,
          isAddHoc      : resp.data.isAddHoc,
          fiturSearching: true,
          title         : "My Team Profile",
          level         : resp.data.level},
          {cssClass: 'select-modal',
          enableBackdropDismiss:false });
        karyawanModal.onDidDismiss(karyawan => {
          let u_id;
          if(karyawan){
            if (karyawan=='me') {
              this.user_id = this.user_data.Employee_ID
            }else{
              this.user_id = karyawan.id
            }
            me.getListData();
          }
        });
        karyawanModal.present();
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });    
  }
}



// WEBPACK FOOTER //
// ./src/pages/opname/list_item_fasker/index.ts